// @flow
import React, {
  useEffect,
  useState,
  useRef,
} from 'react';
import SimpleReactValidator from 'simple-react-validator';
import {
  Input,
} from '../../../design';
import {
  SpText,
  SpWidgetButton,
  SpAmountWidget,
  SpAmountWidgetItem,
  SpMessageText,
  SpTermsAndServices,
  SpError,
} from '../../../widgetDesign';
import { imgWith } from "../../../utils/reseponsive";
import swirepaylogo from '../../../assets/imgs/swirepay-logo.svg';
import formatAmount from '../../../utils/formatAmount';
import star from '../../../assets/imgs/star.png';
import step1 from '../../../assets/imgs/step1.png';
import step2 from '../../../assets/imgs/step2.png';
import arrow from '../../../assets/imgs/arrow.png';
import navLeft from '../../../assets/imgs/left.png';
import navRight from '../../../assets/imgs/right.png';


type Props = {
  payment: Object,
  amountInfo: Function,
  whiteLabel: Boolean,
};

const WidgetInfo = (props: Props) => {
  const {
    payment,
    amountInfo,
    whiteLabel,
  } = props;

  const [, forceUpdate] = useState();
  const amountSelected = payment.paymentWidget.selectedAmount ? payment.paymentWidget.selectedAmount : null;
  const { prefix } = payment.account.currency;
  const currencyType = payment.account.currency;
  const [amountList, setAmountList] = useState([]);
  const [interval, setInterval] = useState(payment.paymentWidget.defaultInterval);
  const [customAmount, setCustomAmount] = useState(amountSelected ? (amountSelected / 100).toFixed(2) : null);
  const [amount, setAmount] = useState(amountSelected ? amountSelected : null);
  const amountRegex = /^\d*\.?\d*$/;
  const simpleValidator = useRef(new SimpleReactValidator());
  const [selectedAmount, setSelectedAmount] = useState(amountSelected ? amountSelected / 100 : null);

  useEffect(() => {
    if (payment && payment.paymentWidget) {
      setAmountList(payment.paymentWidget.amounts);
    }
  }, [payment]);

  const updateAmount = (e) => {
    const { value } = e.currentTarget;
    if (amountRegex.test(value) || value === '') {
      setCustomAmount(value);
    }
  };

  const amountFormat = (e) => {
    const { value } = e.currentTarget;
    const amount = parseFloat(value);
    if (Number(amount)) {
      setCustomAmount(parseFloat(amount, 10).toFixed(2));
      setAmount(amount * 100);
      setSelectedAmount(amount);
    }
  };

  const amountUpdate = (value) => {
    setSelectedAmount(value);
    const amount = parseFloat(value);
    if (Number(amount)) {
      setCustomAmount(parseFloat(amount, 10).toFixed(2));
      setAmount(amount * 100);
    }
  };

  const amountDetails = (event) => {
    event.preventDefault();
    const formValid = simpleValidator.current.allValid();
    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
      return;
    }
    amountInfo({
      amount,
      interval,
    });
  };

  return (
    <>
      <div style={{ padding: '0px 45px', verticalAlign: 'middle' }}>
        <img
          src={navLeft}
          alt="step"
          style={{ marginRight: "55px" }}
        />
        <SpText fontSize="17px">
          Choose Amount
        </SpText>
        <img
          src={navRight}
          alt="step"
          style={{ marginLeft: "50px", cursor: "pointer" }}
          onClick={amountDetails}
        />
      </div>
      <div style={{ textAlign: 'center' }}>
        <img src={step1} alt="step" className="mr-2" />
        <img src={step2} alt="step" className="mr-2" />
        <img src={step2} alt="step" />
      </div>
      <SpMessageText className="mt-4">
        <SpText fontSize="15px">
          {payment.paymentWidget.actionMessage}
        </SpText>
      </SpMessageText>
      <div className="mt-4" style={{ padding: '0px 45px' }}>
        {
          payment.paymentWidget.intervals && payment.paymentWidget.intervals.length !== 0 && (
            <div style={{ backgroundColor: '#f2f2f6', padding: '10px 0px 8px 5px', borderRadius: '30px' }}>
              {
                payment.paymentWidget.intervals.map((item) => (
                  <SpText
                    fontSize="14px"
                    className="mr-3"
                    borderRadius={interval === item ? '30px' : '0px'}
                    padding={interval === item ? '4px 7px' : '0px'}
                    backgroundColor={interval === item ? payment.paymentWidget.primaryColor : 'none'}
                    color={interval === item ? '#fff' : '#000'}
                    style={{ cursor: "pointer" }}
                    onClick={() => setInterval(item)}
                  >
                    <span>
                      {
                        payment.paymentWidget.recommendedInterval === item && (
                          <span>
                            <img src={star} alt="star" style={{ width: '10px', paddingBottom: '3px', verticalAlign: 'middle' }} />
                            &nbsp;
                          </span>
                        )
                      }
                    </span>
                    {
                      item === 'ONETIME' && (
                        <span>One-time</span>
                      )
                    }
                    {
                      item === 'WEEK' && (
                        <span>Weekly</span>
                      )
                    }
                    {
                      item === 'MONTH' && (
                        <span>Monthly</span>
                      )
                    }
                    {
                      item === 'YEAR' && (
                        <span>Yearly</span>
                      )
                    }
                  </SpText>
                ))
              }
            </div>
          )
        }
      </div>
      <SpAmountWidget className="mt-4">
        {
          amountList.map((item) => (
            <SpAmountWidgetItem
              className="mr-3 mb-3"
              onClick={() => amountUpdate(item / 100)}
              style={{
                cursor: "pointer",
                border: selectedAmount === item / 100 ? `1px solid ${payment.paymentWidget.primaryColor}` : 'none',
              }}
            >
              {prefix} {formatAmount((item / 100), currencyType)}
            </SpAmountWidgetItem>
          ))
        }
      </SpAmountWidget>
      <div style={{ padding: '0px 45px' }}>
        {
          !payment.paymentWidget.showCustomAmount ? (
            <>
              <Input
                style={{
                  height: '48px',
                  borderRadius: '6px 0px 0px 6px',
                  width: '20px',
                  borderRight: '1px solid transparent',
                }}
                value={prefix}
              />
              <Input
                style={{
                  height: '48px',
                  borderRadius: '0px 6px 6px 0px',
                  width: '280px',
                  borderLeft: '1px solid transparent',
                }}
                placeholder="0.00"
                onChange={updateAmount}
                onBlur={amountFormat}
                value={customAmount}
                onKeyPress={e => {
                  const keyCode = e.charCode || e.which;
                  if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 44) {
                    e.preventDefault();
                  }
                }}
              />
              <SpError>
                {simpleValidator.current.message('amount', customAmount, 'required')}
              </SpError>
            </>
          ) : (
            <SpError>
              {simpleValidator.current.message('amount', customAmount, 'required',
                { messages: { required: 'The amount is required.' } })}
            </SpError>
          )
        }
      </div>
      <div className="mt-4" style={{ padding: '0px 45px' }}>
        <SpWidgetButton
          backgroundColor={payment.paymentWidget.primaryColor}
          onClick={amountDetails}
        >
          Next <img style={{ verticalAlign: "middle" }} src={arrow} alt="arrow" />
        </SpWidgetButton>
      </div>
      {
        (whiteLabel === false) ? (
          <div className="mt-4 align-items-center" style={{ padding: '0px 45px' }}>
            <SpText
              fontSize="10px"
              color="rgba(0, 0, 0, 0.7)"
              className="mr-2"
            >
              Powered by
            </SpText>
            <span className="mt-3">
              <img style={{ verticalAlign: "middle", paddingBottom: "10px" }} width={imgWith(12)} src={swirepaylogo} alt="" />
            </span>
          </div>
        ) : ''
      }
      <SpTermsAndServices className="mt-2">
        <SpText fontSize="11px" color="rgba(0, 0, 0, 0.7)">
          {payment.paymentWidget.termsAndServices}
        </SpText>
      </SpTermsAndServices>
    </>
  );
};

// $FlowFixMe
export default WidgetInfo;
